import type { ChargerRepository } from '@/core/charger'
import type { UseCase } from '@/core/shared'

export const getOcppSettings: UseCase<ChargerRepository, 'getOcppSettings'> = repository => {
  return async (chargerUid) => {
    return await repository.getOcppSettings(chargerUid)
  }
}
